import { Navigate, useLocation } from "react-router-dom";

export default function LegacyApplicationsRedirect() {
  const location = useLocation();
  return <Navigate to={`/people/membership-services/applications/all${location.search}`} replace />;
}
